import styled from "styled-components";
import { Button, Grid } from "semantic-ui-react";
import { theme } from "../../styling/theme";

export const StickersContainer = styled(Grid.Row)({
  display: "flex !important",
  marginTop: 0,
  backgroundColor: `${theme.backgroundColor}`,
});

export const StickerListGrid = styled(Grid)({
  backgroundColor: "#fff",
  display: "flex !important",
  marginTop: "0px !important",
  marginLeft: "0px !important",
  width: "100%",
  padding: "30px 0px !important",
  flexWrap: "wrap",
  gap: "10px",
});

export const TabContentGrid = styled(Grid)({
  backgroundColor: "#fff",
  display: "flex!important",
  marginTop: "0!important",
  marginLeft: "0!important",
  width: "100%",
  flexWrap: "wrap",
  maxWidth: `${theme.maxWidthSizeContainer}px`,
  marginBottom: "0 !important",
});

export const SaveStickersButton = styled(Button)({
  width: "200px",
  marginBottom: "20px !important",
  marginLeft: "auto !important",
});
